export default "/images/6c44054a095621cdb1e318557cd5ed47.avif";